import React, { useEffect, useState } from 'react'
import {NavLink } from 'react-router-dom'
import { useFirebaseApp } from 'reactfire'

const SubMenu=(props)=>{
  const firebase=useFirebaseApp()
  const firestore=firebase.firestore()

  const [state, setstate] = useState({subCategories:[]})

  useEffect(()=>{
    firestore.collection(`categories`).doc(props.category).get().then(
      doc=>{
        let subCategories=[]
        subCategories.push(...doc.data().subCategories)
        setstate({
          subCategories
        })
      }
    )
    const top=document.getElementById('header').getBoundingClientRect().bottom

    document.documentElement.style.setProperty('--top-submenu',`${top}px`)
    
  },[firestore,props.category])
  return (
    <div className="sub-menu">
      <ul className="sub-menu-list">
        {
          state.subCategories &&
          state.subCategories.map(s=>(
            <li key={s} className="sub-menu-item"><NavLink activeClassName='active' to={`/categorias/${props.category}/${s.toLowerCase()}`}>{s}</NavLink></li>
          ))
        }
      </ul>
    </div>
  )
}

export default SubMenu
